module.exports = __webpack_public_path__ + "static/media/outros.2dd8d3c8.jpg";